module.exports = __webpack_public_path__ + "static/media/RA-QC1701L.4bb0622e.png";